import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getDocumentByUid } from '../actions/prismic';
import { getDocByUid } from '../selectors/entities';
import { getDocByUidError } from '../selectors/errors';
import { getDocByUidLoader } from '../selectors/loaders';

/* TODO : create types for data, error and loading as well as the result object */
function useDocumentByUid<T = any>(
  documentType: string,
  documentUid: string
): { data: T; error: any; loading: any } {
  const dispatch = useDispatch();
  const data = useSelector(getDocByUid(documentType, documentUid)) as T;
  const error = useSelector(getDocByUidError(documentType, documentUid));
  const loading = useSelector(getDocByUidLoader(documentType, documentUid));

  useEffect(() => {
    if (!loading && !error && !data) {
      dispatch(getDocumentByUid(documentType, documentUid));
    }
  }, [dispatch, data, loading, error, documentType, documentUid]);

  return { data, error, loading };
}

export default useDocumentByUid;
